import React from "react";
import styled, { css } from "styled-components";
import { widthMixin } from "./utility";

const _RepaymentsDecrease = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
    <g>
      <path className="st0"
            d="M102.2 138.1c10.7-2.4 18.6-11.9 18.6-22.9l.5-46.7c.5-25.7-20.5-46.9-46.2-47.1H72c-25 2.1-44 22.9-44 47.8l-.2 45c0 11 7.6 20.5 18.3 23.1" />
      <path className="st0"
            d="M114.1 78.6V71v-3.3c-17.6 10-40 6-52.8-9.8-2.9 9.8-11.4 16.7-21.7 17.1-1.7 0-3.1-.2-4.8-.7v3.6M121 89.6v-2.4M63.9 127.7c21.2 5.7 42.9-6.7 48.8-27.9v-.5M35.8 98.9c2.4 9 7.6 17.1 15.5 22.6M27.7 86.7v2.4M62.4 105.5c6.7 6.4 16.9 6.4 23.6 0M95.5 84.8c-1.4-3.3-5-4.8-8.3-3.6-1.7.7-2.9 1.9-3.6 3.6M65.1 83.9c-1.4-3.3-5-4.8-8.3-3.6-1.7.7-2.9 1.9-3.6 3.6M18.2 96v6.9c0 11.7 9.3 20.9 20.7 21.2" />
      <path className="st0" d="M32.2 100.8h-9.3c-2.6 0-4.5-2.1-4.5-4.5v-14c0-2.6 2.1-4.8 4.8-4.8h9.3" />
      <path className="st0"
            d="M27.7 96c0 2.6 2.1 4.8 4.8 4.8s4.8-2.1 4.8-4.8V82c0-2.6-2.1-4.8-4.5-4.8-2.6 0-4.8 1.9-4.8 4.5L27.7 96zM116.2 101.2h9.3c2.6 0 4.8-2.1 4.8-4.8v-14c0-2.6-2.1-4.8-4.5-4.8h-9.3" />
      <path className="st0"
            d="M121 96.7c0 2.6-2.1 4.8-4.8 4.8s-4.8-2.1-4.8-4.8v-14c.2-2.6 2.6-4.5 5-4.3 2.1.2 4 1.9 4.3 4.3l.3 14zM64.8 124.3c0 3.8-3.1 6.9-7.1 6.9-3.8 0-6.9-3.1-6.9-7.1 0-3.8 3.1-6.9 7.1-6.9 3.8 0 6.9 3.3 6.9 7.1z" />
      <path className="st0"
            d="M18.2 88.9v-21C19.1 37 45.1 12.7 76 13.6c29.8 1 53.8 25.2 54.3 55v20.9M39.1 124.1h11.7" />
    </g>
  </svg>
);

export const RepaymentsDecrease = styled(_RepaymentsDecrease).attrs({
  className: "repayments-increase-icon"
})(({ themeColor }) => css`
  ${widthMixin()}
  
  .st0 {
    fill: none;
    stroke: ${themeColor};
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round
  }
`);